"use client";

import { c as _c } from "react/compiler-runtime";
import { PageHeroLayout } from "./page-hero-layout";
import type { HeroSectionProps } from "./types";
export default function HeroSection(t0) {
  const $ = _c(13);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      showActions: t1,
      actions: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const showActions = t1 === undefined ? false : t1;
  let t3;
  if ($[4] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const actions = t3;
  let t4;
  if ($[6] !== actions || $[7] !== showActions) {
    t4 = showActions ? actions : [];
    $[6] = actions;
    $[7] = showActions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props || $[10] !== showActions || $[11] !== t4) {
    t5 = <PageHeroLayout {...props} actions={t4} showActions={showActions} />;
    $[9] = props;
    $[10] = showActions;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}